// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import ReactiveSockJS from "reactive-dao-sockjs"

import logger from 'logger'
logger.addAjaxLogDestination("/saveLogs")
if(!localStorage.test) logger.install()
//ReactiveSockJS.messageLogger = (...args)=>logger.localConsole.info(...args)

import Vue from 'vue'

Vue.config.devtools = true

import AsyncComputed from 'vue-async-computed'
Vue.use(AsyncComputed)

import api from 'api'
import ReactiveDaoVue from 'reactive-dao-vue'
Vue.use(ReactiveDaoVue, {
  dao: api
})

import VueRecaptcha from 'vue-recaptcha'
Vue.component('vue-recaptcha', VueRecaptcha)

import App from './App'
import router from './router'

var script = document.createElement('script')
script.src = "https://www.google.com/recaptcha/api.js?onload=vueRecaptchaApiLoaded&render=explicit"
document.head.appendChild(script)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js